import Styled from 'styled-components';

export const BottomOneTableRow = Styled.div`
box-sizing: border-box;
display: flex;
justify-content: stretch;
align-items: center;
height: 28px;
overflow:hidden;
padding-left: ${({numberOfParents}) =>
	numberOfParents === 1 ? '48px;' : numberOfParents === 2 ? '92px;' : numberOfParents === 0 && '16px;'}


&:hover {
    cursor: pointer;
    background-color:#f8f3fe;
}
`;

export const TypeAndDetailContainer = Styled.div`
display: flex;
justify-content: stretch;
align-items: center;
flex: 1;
height: 100%
box-sizing: border-box;
font-size: 13px;
color: #080927;

>.type{
    width: 166px;
}

>.detail{
    flex: 1;
}
`;

export const BottomOneItem = Styled.div`
display: flex;
justify-content: flex-start;
align-items: center;
box-sizing: border-box;
font-size: 13px;
color: #080927;

padding-right: 16px;
width: 166px;
height: 100%;
order: ${props => props.order};
span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
abbr{
    text-decoration: none;
}

&:hover {
    cursor: pointer;
}
`;

export const BottomOneRightItem = Styled.div`
display: flex;
justify-content: flex-end;
align-items: center;
box-sizing: border-box;
font-size: 13px;
color: #080927;

padding-right: 16px;
width: 166px;
height: 100%;
order: ${props => props.order};
span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}


&:hover {
    cursor: pointer;
}
`;

export const BottomOneGreyItem = Styled(BottomOneItem)`
color: #a1a1a1;
`;

export const BottomOneSpaceItem = Styled.div`
flex: 1;
box-sizing: border-box;
`;

export const BottomOneDetailItem = Styled.div`
display:  flex;
flex:1;
box-sizing: border-box;
width: 166px;
height: 100%;

padding-right: 16px;
font-size: 13px;
color: #080927;
align-items: center;
justify-content: flex-start;
order: ${props => props.order};

    span{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        
    >div {
        display: flex;
        flex: auto;
        justify-content: flex-start;
        align-items: center;
        

        span {

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        }

    }
    }

    abbr{
        text-decoration: none;
    }

`;
